import AnimationHelper from 'modules/AnimationHelper';
import { parseHandleBars } from 'modules/HandlebarsTemplates';
import { FacebookMl3AppShareLink } from 'modules/Native';

const animateProfileMiddleArticleList = AnimationHelper(
  '#profileMiddleArticleList > .articleCard',
  {
    visiblePercent: 10,
  }
);

// =========================

window.ProfilePage = {
  reset: changeProfileListType,
};

let showPrivateMapIfZeroSharedMap = false;

const officialAccountGroupId = '5a092ee0b221246bdcc9c9e3';
const template = parseHandleBars($('#ProfileTemplate').html());
let optoutFinishTemplate;
var url = window.location.href;
if(url.indexOf('finish.php') > 0 ){
  if (Cookies.get('is_device_id') == '0' || !MobileDevice.IsMobile) {
    optoutFinishTemplate = parseHandleBars($('#optoutFinishTemplate').html());
  } else {
    optoutFinishTemplate = parseHandleBars($('#optoutFinishTemplateWithDeviceID').html());
  }
}
let account_id = '';
let lifeMap = {};

let skip = 0;
const limit = 10;
let pos = -1;
let countDisplay = 0;
let iMypage = 0;
const mapListTemplate = parseHandleBars($('#StoreMapCardTemplate').html());
let ajaxObj;
let profileId = '';

const pmal = $('#profileMiddleArticleList');
const pmpl = $('#profileMiddlePhotoList');
const loading = $('#profileMiddleListLoading');

let currentListType = 'all';

$(document).ready(() => {
  sessionStorage.setItem('firstTime','false');
  window.APIGetAllUserData({
    always() {
      const urlData = window.historyObj.getUrlData();
      // check type is already selected
      let type =
        urlData &&
        urlData.searchDic &&
        urlData.searchDic.type &&
        urlData.searchDic.type;
      account_id =
        urlData.searchDic.profile ||
        (Gdata.Profile.ori && Gdata.Profile.ori._id);

      if (
        account_id &&
        Gdata.Profile.ori &&
        Gdata.Profile.ori._id &&
        account_id === Gdata.Profile.ori._id
      ) {
        // show private map tab
        $('.changeProfileListTypemyPrivateMap').show();
        showPrivateMapIfZeroSharedMap = true;
      } else {
        type = type === 'myPrivateMap' ? null : type;
      }

      initializeProfile();
      if (type === "photo") {
        $(".mapOrderContainer").hide();
      } else {
        $(".mapOrderContainer").show();
      }
      changeProfileListType(type);
    },
  });

  window.APIGetMyMaps({
    always() {
      lifeMap =
        Gdata.MyMaps.ori &&
        Gdata.MyMaps.ori.find((map) => {
          return map.is_lifemap === '1';
        });
    },
  });
});

export const checkAdsence = async () => {
  var adsConfig = false;
  await $.getJSON( window.location.origin + '/js/config/adsense.json', {
    format: "json"
  })
    .done(function( data ) {
      if ( typeof data.adsenses.mypage !== 'undefined' && data.adsenses.mypage.display == 'true') {
        adsConfig = data.adsenses.mypage;
      }
      if(!data.block_account){
        adsConfig.block_account = [];
      } else {
        adsConfig.block_account = data.block_account;
      }
    }).catch(() => false);
  return adsConfig; 
};
checkAdsence().then(function(result){
  window.checkAdsenceMypage =result;
});

$(document).on('click', '.changeProfileListType', (e) => {
  const type = $(e.currentTarget).data('type');

  changeProfileListType(type);
  if (type === "photo") {
    $(".mapOrderContainer").hide();
  } else {
    $(".mapOrderContainer").show();
  }
  const obj = window.historyObj.getUrlData({
    parseQuery: true,
    setQuery: {
      type,
    },
  });
  window.historyObj.pushHistoryState(obj.url);
});

function initializeProfile() {
  new Promise((resolve, reject) => {
    if (!account_id) {
      return reject();
    }

    const data = {
      locale: window.hlocale,
    };
    if (Cookies.get(CookieSession)) {
      data.session = Cookies.get(CookieSession);
    }
    data._ids = [account_id];

    window.APIModule.callAPI({
      name: 'AccountReadPublic',
      data,
      success(result) {
        if (result.success && result.response[0]) {
          const account = result.response[0];

          if (account.groups) {
            account.groups.forEach((group) => {
              if (group === officialAccountGroupId) {
                account.is_official = true;
              }
            });
          }

          if (account.homepage) {
            account.homepage_link = account.homepage;
            if (account.homepage_link.indexOf('//') < 0) {
              account.homepage_link = `https://${account.homepage_link}`;
            }
          }

          if (MobileDevice.DeviceOS == 0) {
            account.device = 'iOSShare';
          } else {
            account.device = 'androidShare';
          }

          account.IsMobile = MobileDevice.IsMobile;
          account.DeviceOS = MobileDevice.DeviceOS;
          
          $('#ProfileTemplateContainer').html(template(account));
          if(url.indexOf('finish.php') > 0 ){
            $('#OptoutFinishContainer').html(optoutFinishTemplate(account));
          }

          if (window.translateCollection) {
            window.translateCollection([account], 'account');
          }
          profileId = account._id;
        } else {
          reject();
        }
      },
    });
  }).catch(() => {
    window.location.href = '/';
  });
}
function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1);
      if (c.indexOf(name) != -1) return c.substring(name.length, c.length);
  }
  return "";
}
function changeProfileListType(type) {
  currentListType = type || currentListType || 'timeline';
  pos = -1;
  countDisplay = 0;
  iMypage = 1;
  $('.changeProfileListType').removeClass('active');
  $(`.changeProfileListType${currentListType}`).addClass('active');

  if (ajaxObj && ajaxObj.ajax) {
    ajaxObj.ajax.abort();
  }
  skip = 0;
  Gdata.CurrentDialies.ori = [];
  Gdata.CurrentDialies.dic = {};
  Gdata.CurrentDialies.loaded = 0;
  Gdata.CurrentPhotos.ori = [];
  Gdata.CurrentPhotos.photoSwipeItems = [];

  pmal.html('');
  pmpl.html('');
  loadControl.isRendering = false;

  window.photoWallLoadingInstanceCount = 0;

  loading.show();

  if (currentListType === 'timeline' || currentListType === 'photo') {
    loadControl.callback = doTimelineOrPhoto;
    doTimelineOrPhoto();
  } else {
    loadControl.callback = null;
    getMaps();
  }
}

function doTimelineOrPhoto() {
  if (loadControl.isRendering || Gdata.CurrentDialies.loaded === 2) {
    return;
  }

  loadControl.isRendering = true;

  ajaxObj = window.API({
    apiName: 'DialyRead',
    rest: {
      data: {
        // session: Cookies.get(CookieSession),
        account_id,
        skip,
        limit,
        special_contents: AS.mapSpecialContents,
        locale: window.hlocale,
      },
    },
    callback: {
      always(responseObj) {
        if (responseObj.success) {
          skip += responseObj.response.length;

          if (responseObj.response.length < limit) {
            Gdata.CurrentDialies.loaded = 2;
            loading.hide();
          }

          Gdata.CurrentDialies.ori = _.concat(
            Gdata.CurrentDialies.ori,
            responseObj.response
          );
          Gdata.CurrentDialies.dic = _.keyBy(Gdata.CurrentDialies.ori, '_id');
          window.ObjsToUpdate.dialy.CurrentDialies = Gdata.CurrentDialies;

          const spotList = [];
          const mapList = [];

          responseObj.response.forEach((dialy) => {
            if (!dialy.map) {
              return;
            }

            // api returns deleted_flag = 1, must check
            if (dialy.map.delete_flag === 1) {
              dialy.map = lifeMap;
            }

            // check looking at other profile
            if (Gdata.Profile.ori && Gdata.Profile.ori._id !== account_id) {
              // is other profile
              if (!MapClass.checkShared(dialy.map.share_id)) {
                // don't show private
                console.log('not shared');
                return;
              }
            }

            dialy.share_url = window.parseShareUrl(dialy);
            window.parseDialySpotImages(dialy);

            dialy.reply_count = dialy.reply_count || {};
            dialy.reply_count.good = dialy.reply_count.good || 0;
            try {
              dialy.description = decodeURIComponent(dialy.description || '');
            } catch (e) {
              console.log(e);
            }

            //for photo wall
            _.forEach(dialy.images, (image_id) => {
              const photo = {
                image_id,
                dialy,
                index: Gdata.CurrentPhotos.ori.length,
              };
              Gdata.CurrentPhotos.ori.push(photo);
              Gdata.CurrentPhotos.photoSwipeItems.push(
                window.parsePhotoSwiperItem(image_id, dialy)
              );

              if (currentListType === 'photo') {
                if (window.photoCardTemplate) {
                  pmpl.append(window.photoCardTemplate(photo));
                }
              }
            });

            if (currentListType === 'timeline') {
              if (
                window.dialyTemplate &&
                pmal.children(`.articleCard${dialy._id}`).length <= 0
              ) {
                  if (window.checkAdsenceMypage && window.checkAdsenceMypage.space && pos == -1 && !(window.checkAdsenceMypage.block_account.includes(profileId))) {
                    pos = window.checkAdsenceMypage.space[0];
                  }
                  if ( countDisplay == pos && window.checkAdsenceMypage ) {
                    if (window.checkAdsenceMypage.space[iMypage] != undefined) {
                      pos = countDisplay + window.checkAdsenceMypage.space[iMypage];
                      iMypage++;
                    } else {
                      pos = countDisplay + 5;
                    }
                    var adsBanner = `<div style="margin-bottom:16px">
                                      <ins class="adsbygoogle"
                                      style="display:inline-block;max-width:746px;max-height:140px;min-height:90px;width:100%;height:100%;"
                                      data-ad-client="ca-pub-7001947114355359"
                                      data-ad-slot="8160122743"></ins>
                                      <script>
                                        (adsbygoogle = window.adsbygoogle || []).push({});
                                      </script>
                                    </div>`;
                    pmal.append(adsBanner);
                  }
                pmal.append(window.dialyTemplate(dialy));
                window.initializeComments(dialy._id, 'dialy');
                countDisplay++;
              }
            }

            spotList.push(dialy.spot);
            mapList.push(dialy.map);
          });

          if (window.translateCollection) {
            window.translateCollection(responseObj.response, 'dialy');
            window.translateCollection(spotList, 'spot');
            window.translateCollection(mapList, 'map');
          }

          if (currentListType === 'photo') {
            window.photoCardLoadImage();
            window.photoCardLoadImage();
            window.photoCardLoadImage();

            if (
              Gdata.CurrentDialies.loaded === 2 &&
              Gdata.CurrentPhotos.ori.length === 0
            ) {
              if (window.noItemTemplate && $('.noItemCard').length === 0) {
                pmal.append(
                  window.noItemTemplate({
                    class: 'noItemCard',
                    wallType: 'wtPhoto',
                  })
                );
              }
            }
          } else {
            window.trunk8FoldText();

            if (
              Gdata.CurrentDialies.loaded === 2 &&
              Gdata.CurrentDialies.ori.length === 0
            ) {
              if (window.noItemTemplate && $('.noItemCard').length === 0) {
                pmal.append(
                  window.noItemTemplate({
                    class: 'noItemCard',
                    wallType: 'wtTimeline',
                  })
                );
              }
            }
          }
        }

        loadControl.isRendering = false;

        wallScrollCheck();

        animateProfileMiddleArticleList();
      },
    },
  });
}

function getMaps() {
  const locale =
    currentListType === 'myPrivateMap' ? undefined : window.hlocale;

  window.APIModule.callAPI({
    name: 'MapList',
    data: {
      session: Cookies.get(CookieSession),
      account_id,
      locale,
    },
    success(result) {
      let mapList = [];
      var sort = Gdata.MyMaps.sort || 'update_datetime';
      var sort_direction = Gdata.MyMaps.sort_direction || 'desc';
      $('#mapListProfileOrderSelect').val(sort);
      $('#mapListProfileOrderAscDesc').val(sort_direction);
      if (result.success) {
        mapList = result.response.filter((map) => {
          if (map.is_lifemap) {
            map.title = window.resolveLang('ライフマップ');
          }

          // check official
          const profile = Gdata.Profile.ori;
          if (
            profile &&
            profile.groups &&
            window.CONFIG_ARR.account.checkOfficial(profile.groups)
          ) {
            if (map.is_lifemap) {
              return false;
            }
          }

          if (map.is_wantmap) {
            return false;
          }

          if (map.categories && map.categories[0]) {
            map.cat = map.categories[0].lcategory;
          }

          // Authentication check
          // not need but just to be sure not to show private maps to other users
          if (map.session_account_id !== map.account_id && !map.is_group_map) {
            // other users' maps
            if (!MapClass.checkShared(map.share_id)) {
              return false;
            }
          }
          // Authentication check
          if (currentListType === 'all') {
            return !map.followmap_id;
          } else if (currentListType === 'follow') {
            return !!map.followmap_id;
          } else if (currentListType === 'myPrivateMap' && account_id == map.account_id) {
            return !MapClass.checkShared(map.share_id) && !map.followmap_id;
          } else if (currentListType === 'mySharedMap' && account_id == map.account_id) {
            return MapClass.checkShared(map.share_id) && !map.followmap_id;
          } else if (currentListType === 'Event') {
            return (
              (map.template_id === window.MapClass.template.aliasMap || map.template_id === window.MapClass.template.spotCollectionMap) &&
              !map.followmap_id &&
              (MapClass.checkShared(map.share_id) ||
                map.session_account_id === map.account_id ||
                map.is_group_map)
            );
          }

          return false;
        });
        //  add ads
        mapList = _.orderBy(
          mapList || [],
          [sort, '_id'],
          [sort_direction, 'desc']
        );
        mapList.forEach((map, i) => {
          if (window.checkAdsenceMypage && window.checkAdsenceMypage.space && pos == -1 && !(window.checkAdsenceMypage.block_account.includes(profileId))) {
            pos = window.checkAdsenceMypage.space[0];
          }
            if ( countDisplay == pos && window.checkAdsenceMypage ) {
              if (window.checkAdsenceMypage.space[iMypage] != undefined) {
                pos = countDisplay + window.checkAdsenceMypage.space[iMypage];
                iMypage++;
              } else {
                pos = countDisplay + window.checkAdsenceMypage.space[iMypage - 1];
              }
              var adsBanner = `<div class="profileAds"><ins class="adsbygoogle"
                                style="display:inline-block;max-width:746px;width:100%;height:169px;"
                                data-ad-client="ca-pub-7001947114355359"
                                data-ad-slot="9322350545"></ins>
                                <script>
                                  (adsbygoogle = window.adsbygoogle || []).push({});
                                </script>
                              </div>
                              `;
              pmal.append(adsBanner);
          }
          pmal.append(mapListTemplate(map));
          countDisplay++;
        });

        if (currentListType !== 'myPrivateMap') {
          if (window.translateCollection) {
            window.translateCollection(mapList, 'map');
          }
        }
      }

      if (showPrivateMapIfZeroSharedMap && !mapList.length) {
        showPrivateMapIfZeroSharedMap = false;
        changeProfileListType('myPrivateMap');
        return;
      }
      showPrivateMapIfZeroSharedMap = false;

      loading.hide();

      if (
        mapList.length === 0 &&
        window.noItemTemplate &&
        $('.noItemCard').length === 0
      ) {
        if (currentListType === 'follow') {
          return pmal.append(
            window.noItemTemplate({
              class: 'noItemCard',
              wallType: 'wtFollow',
            })
          );
        } else if (currentListType === 'myPrivateMap') {
          pmal.append(
            window.noItemTemplate({
              class: 'noItemCard',
              wallType: 'wtPrivateMap',
            })
          );
        } else if (currentListType === 'mySharedMap') {
          pmal.append(
            window.noItemTemplate({
              class: 'noItemCard',
              wallType: 'wtSharedMap',
            })
          );
        } else if (currentListType === 'Event') {
          pmal.append(
            window.noItemTemplate({
              class: 'noItemCard',
              wallType: 'wtEvent',
            })
          );
        }
      }

      if (Gdata.Profile.ori && Gdata.Profile.ori._id === account_id) {
        pmal.removeClass('otherProfile');
      } else {
        pmal.addClass('otherProfile');
      }
    },
  });
}

// Load More on scrolled to bottom
let loadControl = {
  difference: 1900,
  isRendering: false,
  callback: undefined,
};
$(window).scroll(() => {
  wallScrollCheck();
});

function wallScrollCheck() {
  const scrollBottom = $(window).scrollTop() + $(window).height();
  const docHeight = $(document).height();
  if (
    docHeight - scrollBottom <= loadControl.difference &&
    loadControl.callback
  ) {
    loadControl.callback();
  }
}
$(document).on('change', '#mapListProfileOrderSelect', function() {
  Gdata.MyMaps.sort = $(this).val();
  pmal.html('');
  pmpl.html('');
  pos = -1;
  countDisplay = 0;
  loading.show();
  getMaps();
});
$(document).on('change', '#mapListProfileOrderAscDesc', function() {
  Gdata.MyMaps.sort_direction = $(this).val();
  pmal.html('');
  pmpl.html('');
  pos = -1;
  countDisplay = 0;
  loading.show();
  getMaps();
});

// call FacebookMl3AppShareLink
$(document).on('click', '#shareFBLinkProfile', function(e) {
  e.preventDefault();
  const dataShareLink = $(this).data('sharelink');
  FacebookMl3AppShareLink(dataShareLink);
});